export const headerAccessesTable : string[] = ['Usuário','Tipo','Email','Telefone','Empresa','Perfil','Validação']

export const accessesTableRequiredFields : string[] = ['name','adminUser','email','phone','company','profileId','approved']

export const headerProfilesTable : string[] = ['Nome do perfil','Certificados','Estoque','Pedidos','Produção','Roteirização','Acessos', 'Editar estoque'] 

export const allPermissions : string[] = ['name','certificates','stock','orders','production','router','accesses', 'edit-stock', 'delete']

export const headerCompanies : string[] = ['CNPJ','Razão social','Inscrição Estadual','Telefone','E-mail','Nome do contato', 'Tipo']

export const companiesFields : string[] = ['cnpj','companyName','stateRegistration','phone','email','contactName', 'companyTypes']